import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Constants from "../../Constants";
import APIUrls from "../../services/APIUrls";
import { downloadFile } from "../../services/authApiRoutes/APImethods";
import $ from "jquery";

const chunkSize = Constants.CHUNK_SIZE;

export default function ImportBulkUsers(prop) {
    const { t } = useTranslation();
  const [files, setFiles] = useState("");
  const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
  const [showProgress, setShowProgress] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (currentChunkIndex !== null) {
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);

  function readAndUploadCurrentChunk() {
    const file = files;
    if (file) {
      const reader = new FileReader();
      const from = currentChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      reader.onload = (e) => uploadChunk(e);
      reader.readAsDataURL(blob);
    } else {
      uploadChunk(null);
    }
  }

  function uploadChunk(readerEvent) {
    const file = files;
    const data = readerEvent ? readerEvent.target.result : {};
    const params = getParams(file);
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    const urlPart = APIUrls.BULK_USER_UPLOAD;
    const url =
      `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}?` + params.toString();
    axios.post(url, data, { headers }).then((response) => {
        if (file) {
          const filesize = file.size;
          const chunks = Math.ceil(filesize / chunkSize) - 1;
          const isLastChunk = currentChunkIndex === chunks;
          if (isLastChunk) {
            setCurrentChunkIndex(null);
          } else {
            setCurrentChunkIndex(currentChunkIndex + 1);
          }
        } else {
          setCurrentChunkIndex(null);
        }
        setShowProgress(false);
        if(response.data.data.body.success) {
            setShowError(false);
            setErrorMessage("");
            setShowSuccess(true);
            cancelBulkUpload();
        } else {
            setShowError(true);
            setErrorMessage(response.data.data.body.errors.error);
            setShowSuccess(false);
        }
      
    });
  }

  function getParams(file) {
    const params = new URLSearchParams();
    if (file) {
      params.set("name", file.name);
      params.set("size", file.size);
      params.set("currentChunkIndex", currentChunkIndex);
      params.set("totalChunks", Math.ceil(file.size / chunkSize));
    }
    return params;
  }

  const handleFileChange = (e) => {
    if (e.target) {
      setFiles(e.target.files[0]);
    }
  };

  const handleUploadClick = (e) => {
    if (!files) {
      return;
    } else {
      setShowProgress(true);
      setCurrentChunkIndex(0);
    }
    if(showProgress){
      $(e.target).attr('aria-describedby', 'show-progress-msg');
    }
    if(showError){
      $(e.target).attr('aria-describedby', 'show-error');
    }
    if(showSuccess){
      $(e.target).attr('aria-describedby', 'show-success');
    }
  };

  const downloadBulkUserTemplate = () => {
    downloadFile(
      APIUrls.DOWNLOAD_BULK_USER_TEMPLATE,
      "IMPORT_BULK_USERS_TEMPLATE.xlsx"
    );
  };
  const downloadBulkUserTemplateKeyDown = (e) => {
    if (e.key === Constants.ENTER) {
      downloadBulkUserTemplate();
    }
  };

  const cancelBulkUpload = () => {
    prop.funct(false);
  }

  const cancelBulkUploadOnKeyDown = (event) => {
    if(event.key === Constants.ENTER){
        cancelBulkUpload();
    }
  }

  function handleDrop(e) {
    e.preventDefault();
    if (e.dataTransfer) {
      setFiles(e.dataTransfer.files[0]);
    }
  }

  useEffect(() => {
    $(".lastdisable").trigger("focus");
  }, [])

  return (
    <div className="step-1-section importbulk-section">
    <div className="upload-file-block">
      <h3>{`${t('settings_user_management_bulk_users')}`}</h3>
    
      <div className="upload-file-container" onDragOver={(e) => { e.preventDefault(); }} onDragLeave={(e) => { e.preventDefault(); }}
      onDrop={(e) => handleDrop(e)}>
        <div className="upload-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
          >
            <path
              d="M31.125 34C31.125 34 38.398 34 39.0857 34C42.9051 34 46 30.8778 46 27.0255C46 23.1733 42.9051 20.0502 39.0857 20.0502C39.0682 20.0502 39.0525 20.0528 39.035 20.0528C39.0884 19.6168 39.1251 19.1754 39.1251 18.7252C39.1251 12.8021 34.366 8 28.4939 8C23.9185 8 20.0309 10.921 18.5311 15.0098C17.58 14.0485 16.264 13.4526 14.8115 13.4526C11.9074 13.4526 9.55363 15.8272 9.55363 18.7561C9.55363 18.8311 9.56238 18.9035 9.565 18.9777C6.35813 19.8719 4 22.8281 4 26.3476C4 30.5741 7.39588 34 11.5863 34C12.3099 34 18.875 34 18.875 34"
              stroke="#96ACCC"
              strokeWidth="2.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 28L25 23L29 28"
              stroke="#96ACCC"
              strokeWidth="2.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
            <path
              d="M25 41V24"
              stroke="#96ACCC"
              strokeWidth="2.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <div className="upload-format">
        {`${t('settings_user_management_bulk_users_upload_excel_file_note')}`}
        &nbsp;<a tabIndex={0} onClick={downloadBulkUserTemplate} onKeyDown={(e)=>downloadBulkUserTemplateKeyDown(e)} aria-label="Import bulk user template">{`${t('settings_user_management_bulk_users_template_link')}`}</a>
        </div>
        <div className="file-drag">{`${t('upload_drag_drop_files_here')}`}</div>
        <div className="input-file-container">
          <div className="input-file">
            <input
              type="file"
              id="files"
              tabIndex={0}
              onChange={handleFileChange}
            />
            <label className="file-button" htmlFor="files">
            {`${t('choose_file')}`}
            </label>
          </div>
          <div className="upload-file-ext flex-center">
            <div className="inline-flex">
            <strong className={files ? "show-flex" : "hide"}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
              >
                <path
                  d="M6.71373 3.85714V2.57143H5.42801V3.85714H6.71373ZM7.99944 5.14286V3.85714H6.71373V5.14286H7.99944ZM6.71373 6.42857V5.14286H5.42801V6.42857H6.71373ZM7.99944 7.71429V6.42857H6.71373V7.71429H7.99944ZM15.0307 3.81696C15.2182 4.00446 15.3789 4.25893 15.5128 4.58036C15.6468 4.90179 15.7137 5.19643 15.7137 5.46429V17.0357C15.7137 17.3036 15.62 17.5312 15.4325 17.7188C15.245 17.9062 15.0173 18 14.7494 18H1.24944C0.981585 18 0.753906 17.9062 0.566406 17.7188C0.378906 17.5312 0.285156 17.3036 0.285156 17.0357V0.964286C0.285156 0.696429 0.378906 0.46875 0.566406 0.28125C0.753906 0.09375 0.981585 0 1.24944 0H10.2494C10.5173 0 10.8119 0.0669643 11.1334 0.200893C11.4548 0.334821 11.7093 0.495536 11.8968 0.683036L15.0307 3.81696ZM10.5709 1.36607V5.14286H14.3477C14.2807 4.94866 14.207 4.81138 14.1267 4.73103L10.9827 1.58705C10.9023 1.5067 10.7651 1.43304 10.5709 1.36607ZM14.428 16.7143V6.42857H10.2494C9.98158 6.42857 9.75391 6.33482 9.56641 6.14732C9.37891 5.95982 9.28516 5.73214 9.28516 5.46429V1.28571H7.99944V2.57143H6.71373V1.28571H1.57087V16.7143H14.428ZM8.13002 9.4721L9.2048 12.9777C9.25837 13.1585 9.28516 13.3326 9.28516 13.5C9.28516 14.0558 9.04241 14.5162 8.55692 14.8811C8.07143 15.2461 7.45703 15.4286 6.71373 15.4286C5.97042 15.4286 5.35603 15.2461 4.87054 14.8811C4.38504 14.5162 4.1423 14.0558 4.1423 13.5C4.1423 13.3326 4.16908 13.1585 4.22266 12.9777C4.36328 12.5558 4.76507 11.2299 5.42801 9V7.71429H6.71373V9H7.50725C7.65458 9 7.78516 9.04353 7.899 9.13058C8.01283 9.21763 8.08984 9.33147 8.13002 9.4721ZM6.71373 14.1429C7.06864 14.1429 7.37165 14.0792 7.62277 13.952C7.87388 13.8248 7.99944 13.6741 7.99944 13.5C7.99944 13.3259 7.87388 13.1752 7.62277 13.048C7.37165 12.9208 7.06864 12.8571 6.71373 12.8571C6.35882 12.8571 6.0558 12.9208 5.80469 13.048C5.55357 13.1752 5.42801 13.3259 5.42801 13.5C5.42801 13.6741 5.55357 13.8248 5.80469 13.952C6.0558 14.0792 6.35882 14.1429 6.71373 14.1429Z"
                  fill="#157EFB"
                />
              </svg>
            </strong>
            <span>{files?.name}</span>
            </div>
           
          </div>
          <div className={ showProgress ? "right-progressbar mar-bot16" : "right-progressbar hide" } id="show-progress-msg" role="alert">
          {`${t('settings_user_management_bulk_users_upload_progress')}`}
          </div>
          <div className={ "error upload-error" + (showError === true ? " show" : " hide")} id="show-error" role="alert">
            {errorMessage}
          </div>
          <div className={ "success-message" + (showSuccess === true ? " show" : " hide")} id="show-success" role="alert">
          {`${t('settings_user_management_bulk_users_upload_success')}`}
          </div>
          <button
            aria-label="Upload"
            className="btn"
            onClick={handleUploadClick}
          >
            {`${t('button_upload')}`}
          </button>
        </div>
      </div>
    </div>
    <div className="stricy-btn flex flex-center no-rightlist justify-end">
      <div className="left flex">
        <div>
          <button aria-label="back" className="btn-default" onClick={cancelBulkUpload} onKeyDown={(e) => cancelBulkUploadOnKeyDown(e)}>{`${t('button_back')}`}</button>
       </div>
      </div>
    </div>
    </div>
  );
}
